import { useState } from 'react';
import { toast } from '@yakit/ui-components';

import { putCancelAgreement } from '@VDL/api';

export const useFetchCancel = () => {
  const [isLoading, setIsLoading] = useState(false);

  const fetchCancel = async (level0Code: string) => {
    setIsLoading(true);

    try {
      await putCancelAgreement(level0Code);
      toast.success('Успешно отменено');
    } catch {
      toast.error('Ошибка при отмене согласования');
    } finally {
      setIsLoading(true);
    }
  };

  return { fetchCancel, isLoading };
};
